const uniq = (arr) => [...new Set(arr.filter(Boolean))];

const Chips = ({ name, options, value, onChange }) => (
  <div className="mb-4">
    <p className="text-[11px] uppercase tracking-[0.25em] text-[#6D5A50] mb-2">{name}</p>
    <div className="flex flex-wrap gap-2">
      {options.map((o) => (
        <button
          key={o}
          type="button"
          onClick={() => onChange(o)}
          data-testid={`option-${name.toLowerCase()}-${o}`}
          className={`px-3.5 py-1.5 rounded-full border text-sm transition-colors duration-300 ${
            value === o
              ? "bg-[#4B3A2F] text-[#F9F6F0] border-[#4B3A2F]"
              : "bg-white text-[#4B3A2F] border-[#D9CBB8] hover:border-[#4B3A2F]"
          }`}
        >
          {o}
        </button>
      ))}
    </div>
  </div>
);

export const pickVariant = (variants, sel) => {
  const colors = uniq(variants.map((v) => v.color));
  const sizes = uniq(variants.map((v) => v.size));
  if (!colors.length && !sizes.length) return variants.find((v) => v.id === sel.label) || null;
  return (
    variants.find(
      (v) => (!colors.length || v.color === sel.color) && (!sizes.length || v.size === sel.size),
    ) || null
  );
};

export const OptionPicker = ({ variants, sel, setSel }) => {
  const colors = uniq(variants.map((v) => v.color));
  const sizes = uniq(
    variants.filter((v) => !colors.length || v.color === sel.color).map((v) => v.size),
  );
  if (!colors.length && !sizes.length) {
    if (variants.length < 2) return null;
    return (
      <div className="mb-4">
        <p className="text-[11px] uppercase tracking-[0.25em] text-[#6D5A50] mb-2">Option</p>
        <div className="flex flex-wrap gap-2">
          {variants.map((v) => (
            <button
              key={v.id}
              type="button"
              onClick={() => setSel({ label: v.id })}
              data-testid={`option-label-${v.id}`}
              className={`px-3.5 py-1.5 rounded-full border text-sm transition-colors duration-300 ${
                sel.label === v.id ? "bg-[#4B3A2F] text-[#F9F6F0] border-[#4B3A2F]" : "bg-white text-[#4B3A2F] border-[#D9CBB8]"
              }`}
            >
              {v.label}
            </button>
          ))}
        </div>
      </div>
    );
  }
  return (
    <>
      {colors.length > 1 && (
        <Chips name="Color" options={colors} value={sel.color} onChange={(color) => setSel({ ...sel, color })} />
      )}
      {sizes.length > 0 && (
        <Chips name="Size" options={sizes} value={sel.size} onChange={(size) => setSel({ ...sel, size })} />
      )}
    </>
  );
};
